import { addDuration, addEventListeners, relativeNow } from '@datadog/browser-core';
export var MAX_PAGE_STATE_ENTRIES = 500;
var pageStateEntries = [];
var currentPageState;
export function startPageStateHistory() {
    addPageState(getPageState());
    var stop = addEventListeners(window, [
        "pageshow" /* PAGE_SHOW */,
        "focus" /* FOCUS */,
        "blur" /* BLUR */,
        "visibilitychange" /* VISIBILITY_CHANGE */,
        "resume" /* RESUME */,
        "freeze" /* FREEZE */,
        "pagehide" /* PAGE_HIDE */,
    ], function (event) {
        // Only get events fired by the browser to avoid false currentPageState changes done with custom events
        // cf: developer extension auto flush: https://github.com/DataDog/browser-sdk/blob/2f72bf05a672794c9e33965351964382a94c72ba/developer-extension/src/panel/flushEvents.ts#L11-L12
        if (!event.isTrusted) {
            return;
        }
        if (event.type === "freeze" /* FREEZE */) {
            addPageState("frozen" /* FROZEN */);
        }
        else if (event.type === "pagehide" /* PAGE_HIDE */) {
            addPageState(event.persisted ? "frozen" /* FROZEN */ : "terminated" /* TERMINATED */);
        }
        else {
            addPageState(getPageState());
        }
    }, { capture: true }).stop;
    return {
        findAll: function (startTime, duration) {
            var entries = [];
            var endTime = addDuration(startTime, duration);
            for (var i = pageStateEntries.length - 1; i >= 0; i--) {
                var stateStartTime = pageStateEntries[i].startTime;
                if (stateStartTime >= endTime) {
                    continue;
                }
                entries.unshift(pageStateEntries[i]);
                if (stateStartTime < startTime) {
                    break;
                }
            }
            return entries.length ? entries : undefined;
        },
        stop: stop,
    };
}
function getPageState() {
    if (document.visibilityState === 'hidden') {
        return "hidden" /* HIDDEN */;
    }
    if (document.hasFocus()) {
        return "active" /* ACTIVE */;
    }
    return "passive" /* PASSIVE */;
}
export function addPageState(nextPageState, maxPageStateEntries) {
    if (maxPageStateEntries === void 0) { maxPageStateEntries = MAX_PAGE_STATE_ENTRIES; }
    if (nextPageState === currentPageState) {
        return;
    }
    currentPageState = nextPageState;
    if (pageStateEntries.length === maxPageStateEntries) {
        pageStateEntries.shift();
    }
    pageStateEntries.push({ state: currentPageState, startTime: relativeNow() });
}
export function resetPageStates() {
    pageStateEntries = [];
    currentPageState = undefined;
}
//# sourceMappingURL=pageStateHistory.js.map